import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  parseLanguageFromPath,
  buildLanguageUrl,
  SupportedLanguage,
  supportedLanguages,
} from "../utils/languageRoutes";

export const SeoMeta = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    const { language, path } = parseLanguageFromPath(location.pathname);
    const baseUrl = "https://taxischipholairport.net";

    // Remove existing hreflang links
    const existingLinks = document.querySelectorAll("link[hreflang]");
    existingLinks.forEach((link) => link.remove());

    // Create hreflang links for all languages
    supportedLanguages.forEach((lang) => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = lang;
      link.href = `${baseUrl}${buildLanguageUrl(path, lang)}`;
      document.head.appendChild(link);
    });

    // Add x-default hreflang (points to English version)
    const defaultLink = document.createElement("link");
    defaultLink.rel = "alternate";
    defaultLink.hreflang = "x-default";
    defaultLink.href = `${baseUrl}${buildLanguageUrl(path, "en")}`;
    document.head.appendChild(defaultLink);

    // Update HTML lang attribute
    document.documentElement.lang = language;

    // Update canonical URL
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.appendChild(canonicalLink);
    }
    (canonicalLink as HTMLLinkElement).href = `${baseUrl}${location.pathname}`;
  }, [location.pathname, i18n.language]);

  return null;
};
